import { Stack } from "@altimateai/lego";
import { Button, Typography } from "@altimateai/lego";
import { Link } from "react-router-dom";
import { DismissibleAlertBanner } from "@/components/banners/DismissibleAlertBanner";
import DocumentsList from "./DocumentsList";
import { useBreadcrumb } from "@/components/breadcrumbs";

export default function KnowledgeCatalog() {
  useBreadcrumb("Knowledge Hub", {
    defaultParents: [{ label: "Datamates", pathname: "/datamates" }],
  });

  return (
    <Stack className="al-p-6 al-gap-8" direction="column">
      <Stack direction="row" justify="between" align="center">
        <Typography variant="page-heading">Knowledge Hub</Typography>
        <Button asChild>
          <Link to="/knowledge-hub/new">Create New Knowledge</Link>
        </Button>
      </Stack>

      <DismissibleAlertBanner
        bannerId="knowledge-catalog"
        title="Altimate Knowledge Hub"
        content="Altimate Knowledge hub channels your organisation's tribal knowledge and best practices into verified Context for your IDEs. Achieve reliable AI workflows that deliver uniquely relevant outputs, curbing hallucinations and moving beyond generic code generation"
      />

      <DocumentsList />
    </Stack>
  );
}
